var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumbleiconsShareLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12857 5.72857L10.3857 4.47143C11.0143 3.84286 12.2714 3.84286 12.9 4.47143L13.5286 5.1C14.1571 5.72857 14.1571 6.98571 13.5286 7.61429L10.3857 10.7571C9.75714 11.3857 8.5 11.3857 7.87143 10.7571M7.87143 13.2714L6.61429 14.5286C5.98571 15.1571 4.72857 15.1571 4.1 14.5286L3.47143 13.9C2.84286 13.2714 2.84286 12.0143 3.47143 11.3857L6.61429 8.24286C7.24286 7.61429 8.5 7.61429 9.12857 8.24286",
    stroke: "#A60CFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumbleiconsShareLink);
export default __webpack_public_path__ + "static/media/humbleicons_share_link.081014c71822462120f9f587b3ddcd85.svg";
export { ForwardRef as ReactComponent };